(function () {
  if (window.cvBundleGiftsLoaded) return;
  window.cvBundleGiftsLoaded = true;

  var BUNDLE_HANDLE = window.cvBundleHandle || 'celyra-vera';
  var GIFT_IDS = (window.cvBundleGiftVariantIds || []).map(Number).filter(Boolean);
  var GIFT_PROP = '_free_gift';

  if (!GIFT_IDS.length) return;

  var isSyncing = false;
  var debounceTimer = null;

  function reloadCart() {
    try {
      if (window.Alpine && Alpine.store && Alpine.store('xMiniCart')) {
        Alpine.store('xMiniCart').reLoad();
      }
    } catch (e) {}
  }

  async function syncGifts() {
    if (isSyncing) return;
    isSyncing = true;
    try {
      var res = await fetch('/cart.js');
      var cart = await res.json();
      var items = cart.items;

      var hasBundle = items.some(function (i) { return i.handle === BUNDLE_HANDLE; });
      var giftItems = items.filter(function (i) {
        return i.properties && i.properties[GIFT_PROP] === '1';
      });

      if (hasBundle) {
        var presentIds = giftItems.map(function (i) { return i.variant_id; });
        var toAdd = GIFT_IDS.filter(function (id) { return !presentIds.includes(id); });
        if (toAdd.length > 0) {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: toAdd.map(function (id) {
                return { id: id, quantity: 1, properties: { [GIFT_PROP]: '1' } };
              })
            })
          });
          reloadCart();
        }
      } else if (giftItems.length > 0) {
        var updates = {};
        giftItems.forEach(function (i) { updates[i.key] = 0; });
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
        reloadCart();
      }
    } catch (e) {
      // silent fail
    } finally {
      isSyncing = false;
    }
  }

  function debouncedSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncGifts, 150);
  }

  document.addEventListener('eurus:cart:items-changed', debouncedSync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncGifts);
  } else {
    syncGifts();
  }
})();
